import {
    Component,
    Output,
    EventEmitter,
    OnInit,
    OnDestroy,
    Input
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { enterKey } from '../constants-types/constants';
import { SearchService } from '../core-services/Search.dataservice';
import { TranslationService } from '../translations/Translation.service';

enum SearchContents {
    Empty,
    Text
}

@Component({
    selector: 'pi-search',
    template: `
        <div
            class="piNav-searchBar"
            [ngClass]="{
                'piNav-searchBar--notEmpty': !inputEmpty()
            }"
        >
            <div class="piNav-searchBar--inputWrapper">
                <input
                    type="text"
                    class="form-control"
                    [(ngModel)]="textBoxValue"
                    placeholder="{{ TR.key('text.common-terms.search') }}"
                    (keydown)="keyPressed($event)"
                    data-testing="piSearch"
                    [disabled]="isDisabled"
                />
                <div
                    class="clear-icon fa fa-close"
                    (click)="clearValue()"
                ></div>
            </div>
        </div>
    `,
    standalone: false
})
export class SearchComponent implements OnInit, OnDestroy {
    // Events that are emitted
    @Output()
    readonly onTextChange = new EventEmitter<any>();
    @Output()
    readonly onCleared = new EventEmitter<any>();
    @Input()
    isDisabled = false;

    contents: SearchContents = SearchContents.Empty;
    textFieldChanged = false;

    private _textBoxValue = '';
    private searchTermSubscription: Subscription;

    constructor(
        public TR: TranslationService,
        private router: Router,
        private route: ActivatedRoute,
        private searchService: SearchService
    ) {}

    get textBoxValue() {
        return this._textBoxValue;
    }

    set textBoxValue(val) {
        if (val && val.trim()) {
            this.contents = SearchContents.Text;
            this.textFieldChanged = true;
        } else {
            this.contents = SearchContents.Empty;
        }
        this._textBoxValue = val;
        this.onTextChange.emit(val);
    }

    ngOnInit() {
        this.searchTermSubscription = this.searchService.searchTerm.subscribe(
            (value) => (this.textBoxValue = value)
        );
    }

    ngOnDestroy() {
        this.searchTermSubscription.unsubscribe();
    }

    clearValue() {
        this.textBoxValue = '';
        this.onCleared.emit();
    }

    inputEmpty(): boolean {
        return this.contents === SearchContents.Empty;
    }

    keyPressed(event: KeyboardEvent): void {
        if (event.key === enterKey) {
            const searchTerms = this.textBoxValue || '';
            this.router.navigate(['/searchResults', searchTerms], {
                relativeTo: this.route
            });
        }
    }
}
